const mappingElementIdsToAttributes = (elementIds, attributes) =>
  elementIds.reduce(
    (acc, elementId) => ({
      ...acc,
      [elementId]: attributes && elementIds.includes(elementId) ? attributes : [],
    }),
    {}
  );

export default mappingElementIdsToAttributes;
